//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { axiosPost } from '../../../../axios/axios.js'

import { mapGetters } from 'vuex'
import manba from 'manba'

export default {
  props: {
    date: {
      type: Number,
      default: null
    },
    scheduleForEdit: {
      type: Array,
      default () {
        return []
      }
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      scheduleType: { name: '3/3', key: '3/3', workDaysCount: 3, daysOffCount: 3 },
      interval: {
        start: null,
        end: null
      },
      selectWorkShift: {
        name: null,
        key: null,
        startHour: null,
        endHour: null
      },
      loading: false,

      autoExtendMode: 'nextYear',
      autofillData: {
        autofillAllowed: true,
        autofillIntervals: [{ startTime: null, endTime: null }],
        autofillSpacesRule: 'useCurrentConfig',
        autofillMergeRule: 'rewriteManual',
        autofillRule: {
          type: 'shiftWork',
          startFillDate: null,
          deep: null,
          startHour: 9,
          endHour: 17,
          workDaysCount: null,
          daysOffCount: null,
          daysShift: null,
          workShift: null
        },
        autofillAutoAssignToBrigade: true,
        autofillCanPerformRequests: true,
        isOfficeAllowed: true,
        isDepartureAllowed: true
      },

      types: [
        { name: 'Посменный', key: 'shiftWork' },
        { name: 'Офисный', key: 'regularWork' }
      ],
      scheduleTypes: [
        { name: '1/3', key: '1/3', workDaysCount: 1, daysOffCount: 3 },
        { name: '1/5', key: '1/5', workDaysCount: 1, daysOffCount: 5 },
        { name: '1/6', key: '1/6', workDaysCount: 1, daysOffCount: 6 },
        { name: '2/2', key: '2/2', workDaysCount: 2, daysOffCount: 2 },
        { name: '2/4', key: '2/4', workDaysCount: 2, daysOffCount: 4 },
        { name: '3/3', key: '3/3', workDaysCount: 3, daysOffCount: 3 },
        { name: '4/3', key: '4/3', workDaysCount: 4, daysOffCount: 3 },
        { name: '4/4', key: '4/4', workDaysCount: 4, daysOffCount: 4 },
        { name: '5/2', key: '5/2', workDaysCount: 5, daysOffCount: 2 },
        { name: '7/0', key: '7/0', workDaysCount: 7, daysOffCount: 0 }
      ]
    }
  },
  computed: {
    ...mapGetters({
      getWorkShifts: 'getWorkShifts',
      user: 'getUser'
    }),
    workShifts: function () {
      return [
        {
          name: 'Своя смена',
          key: 'brigadier.custom',
          startHour: 8,
          endHour: 17
        },
        ...this.getWorkShifts.filter(ws => ws.active)
      ]
    },
    employeeIds: function () {
      return this.scheduleForEdit && this.scheduleForEdit.map(worker => worker.id)
    },
    selectWorkShiftStartHour: {
      get: function () {
        return this.selectWorkShift.startHour
      },
      set: function (newValue) {
        this.selectWorkShift.startHour = newValue
      }
    },
    selectWorkShiftEndHour: {
      get: function () {
        return this.selectWorkShift.endHour > 24 ? (this.selectWorkShift.endHour - 24) : this.selectWorkShift.endHour
      },
      set: function (newValue) {
        this.selectWorkShift.endHour = newValue
      }
    },
    multipleEdit: function () {
      return this.scheduleForEdit && this.scheduleForEdit.length > 1
    }
  },
  created: function () {
    this.interval.start = manba(new Date(this.date).getTime()).format('DD.MM.YYYY')
    this.selectWorkShift = this.workShifts.find(workShift => workShift.key === 'brigadier.7-19')
  },
  methods: {
    preparAutofillRule: function () {
      const schedule = this.scheduleForEdit[0].schedule[0]
      if (schedule && schedule.autofillIntervals && schedule.autofillRule) {
        this.autofillData.autofillRule.type = schedule.autofillRule.type
        if (schedule.autofillRule.type === 'shiftWork') {
          this.scheduleType = this.scheduleTypes.find(type => type.workDaysCount === schedule.autofillRule.workDaysCount && type.daysOffCount === schedule.autofillRule.daysOffCount)
        }

        const workShiftKey = schedule.autofillRule.workShift || 'brigadier.custom'
        this.selectWorkShift = JSON.parse(JSON.stringify(this.workShifts.find(workShift => workShift.key === workShiftKey) || this.selectWorkShift))
        if (workShiftKey === 'brigadier.custom') {
          this.selectWorkShift.startHour = schedule.autofillRule.startHour
          this.selectWorkShift.endHour = schedule.autofillRule.endHour > 24 ? (schedule.autofillRule.endHour - 24) : schedule.autofillRule.endHour
        }
      }
    },
    onSave: function () {
      this.loading = true

      const bodyFormData = new FormData()

      const startTime = this.parseDate(this.interval.start).getTime()
      const startFillDate = startTime

      let endTime
      if (this.autoExtendMode === 'handle' && this.interval.end) {
        endTime = this.parseDate(this.interval.end).getTime()
      } else if (this.autoExtendMode === 'nextYear') {
        const endNextYearTime = new Date(new Date(this.date).getFullYear() + 1, 11, 31).getTime()
        endTime = endNextYearTime
      } else {
        const endCurrentYearTime = new Date(new Date(this.date).getFullYear(), 11, 31).getTime()
        endTime = endCurrentYearTime
      }
      const deep = Math.floor(endTime - startTime) / (1000 * 60 * 60 * 24) + 1

      this.autofillData.autofillIntervals[0].startTime = startTime
      this.autofillData.autofillIntervals[0].endTime = endTime

      if (this.autoExtendMode === 'handle') {
        this.autofillData.autofillRule.startFillDate = startFillDate
        this.autofillData.autofillRule.deep = deep
        this.autofillData.autofillRule.workShift = this.selectWorkShift.key === 'brigadier.custom' ? null : this.selectWorkShift.key
        this.autofillData.autofillRule.startHour = this.selectWorkShift.startHour
        this.autofillData.autofillRule.endHour = this.selectWorkShift.endHour < this.selectWorkShift.startHour ? (this.selectWorkShift.endHour + 24) : this.selectWorkShift.endHour
        if (this.autofillData.autofillRule.type === 'shiftWork') {
          this.autofillData.autofillRule.workDaysCount = this.scheduleType.workDaysCount
          this.autofillData.autofillRule.daysOffCount = this.scheduleType.daysOffCount
        }
        const startYearTime = new Date(new Date(this.date).getFullYear(), 0, 1).getTime()
        this.autofillData.autofillRule.daysShift = Math.floor(startTime - startYearTime) / (1000 * 60 * 60 * 24)
      } else {
        this.autofillData.autofillRule = {
          startFillDate: startFillDate,
          deep: deep
        }
        this.autofillData.autoExtend = true
      }
      bodyFormData.set('data', JSON.stringify(this.autofillData))
      bodyFormData.set('id', this.employeeIds.toString())
      bodyFormData.set('apply ', true)

      axiosPost({
        url: '/service/delta/workday/setautofill',
        data: bodyFormData,
        onSuccess: () => {
          this.$q.notify({
            type: 'positive',
            message: 'Расписание настроено',
            progress: true,
            timeout: 3000
          })

          this.$emit('record-updated')
          this.$emit('close')
          this.opened = false
        },
        onFailure: (response) => {
          this.$q.notify({
            type: 'negative',
            message: response.result.message,
            progress: true,
            timeout: 8000
          })
        }
      }).finally(() => {
        this.loading = false
      })
    },
    onClose: function () {
      this.opened = false
      this.$emit('close')
    },
    optionsStartFn: function (date) {
      return new Date(date).getTime() >= (new Date().getTime() - 1000 * 60 * 60 * 24)
    },
    optionsEndFn: function (date) {
      return new Date(date).getTime() >= this.parseDate(this.interval.start).getTime()
    },
    closePopupStart: function () {
      this.$refs.popupStart.hide()
    },
    closePopupEnd: function () {
      this.$refs.popupEnd.hide()
    },
    parseDate: function (value) {
      const pattern = /(\d{2}).(\d{2}).(\d{4})/
      return new Date(value.replace(pattern, '$3-$2-$1T00:00:00'))
    }
  }
}

